import styled from 'styled-components';
import { Label } from 'common/baseComponents'
import { SIZE, LAYERS } from 'common/sizes';

import { LABEL, LIST } from 'common/base';

export const MainContainer = styled.nav`
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const IFrame = styled.iframe`
    width: 100%;
    height: 100%;
    display: flex;
`;